var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFattyAcids = function SvgFattyAcids(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#537A5E",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M12.737 17.115a4.76 4.76 0 0 1-9.52 0c0-3.418 2.804-6.833 4.108-8.237a.88.88 0 0 1 1.304 0c1.304 1.403 4.108 4.819 4.108 8.237Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.977 19.65a2.625 2.625 0 0 1-2.624-2.625"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.781,
    cy: 6.49,
    r: 4.364
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.602,
    cy: 15.692,
    r: 2.82
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M13.681 6.49c0-1.16.94-2.1 2.1-2.1M17.966 15.692c0-.351.284-.636.636-.636"
  }))));
};
export default SvgFattyAcids;